import actionTypes from './actionTypes';

export const submit = ({
  reducerName, url, data, requestVerb, options,
}) => ({
  type: actionTypes.SUBMIT,
  reducerName,
  payload: {
    url,
    data,
    requestVerb,
    options,
  },
});

export const submitted = ({ reducerName, data }) => ({
  type: actionTypes.SUBMITTED,
  reducerName,
  payload: {
    data,
  },
});

export const failed = ({ reducerName, error }) => ({
  type: actionTypes.FAILED,
  reducerName,
  payload: {
    error,
  },
});

export const destroy = ({ reducerName, errors, message }) => ({
  type: actionTypes.DESTROY,
  reducerName,
});
